{
  "APP_NAME": "verein.cloud®",
  "Verein": "Verein",
  "Vereins": "Vereins",
  "ABOUT_VEREIN": "With verein.cloud® we open up added value and sources of income for associations that go beyond the premium income. A donation platform creates automated access to the financing of plans and projects. With the profiled access to club members, clubs can integrate their sponsors more sustainably. Members and associations benefit from loyalty, voucher or cash back functions and other added value and services.",
  "PASSWORD_RESET_SUCCESS_MESSAGE": "A password reset link has been sent. Check your inbox for an email from support@verein.cloud.",
  "New Version is Available.": "A New Version is Available.",
  "Please Click to Update": "Please Click to Update",
  "Forgot Password": "Forgot Password",
  "Back to login": "Back to login",
  "Submit": "Submit",
  "Welcome": "Welcome",
  "Login Successful": "Login Successful",
  "Your account has been deleted. Please contact support. Logging out...": "Your account has been deleted. Please contact support. Logging out...",
  "Your account has been deleted. Please contact support.": "Your account has been deleted. Please contact support.",
  "Admin": "Admin",
  "Member": "Member",
  "Guest": "Guest",
  "Secretary": "Secretary",
  "Functionary": "Functionary",
  "Editor": "Editor",
  "User": "User",
  "Member Light": "Member Light",
  "Member Light Admin": "Member Light Admin",
  "About": "About",
  "Chairman": "Chairman",
  "Hello world !": "Hello world !",
  "Not Found": "Not Found",
  "Unauthorized Access": "Unauthorized Access",
  "Home": "Home",
  "Logged in as": "Logged in as",
  "Login": "Login",
  "Logout": "Logout",
  "Confirm Password": "Confirm Password",
  "Password": "Password",
  "Password is required": "Password is required",
  "Username": "Username",
  "Username is required": "Username is required",
  "Username or password incorrect.": "Username or password incorrect.",
  "Remember me": "Remember me",
  "Version": "Version",
  "Details": "Details",
  "Yes": "Yes",
  "No": "No",
  "Old Password": "Old Password",
  "New Password": "New Password",
  "Confirmation": "Confirmation",
  "Delete Confirmation": "Delete Confirmation",
  "Move to Trash Confirmation": "Move to Trash Confirmation",
  "Leave Confirmation": "Leave Confirmation",
  "Join Confirmation": "Join Confirmation",
  "Approve Join Confirmation": "Approve Join Confirmation",
  "Accept Confirmation": "Accept Confirmation",
  "Deny Confirmation": "Deny Confirmation",
  "Approve Confirmation": "Approve Confirmation",
  "Reject Confirmation": "Reject Confirmation",
  "Shifts Delete Confirmation": "Shifts Delete Confirmation",
  "Accept Successful": "Accept Successful",
  "Deny Successful": "Deny Successful",
  "Unapprove Successful": "Unapprove Successful",
  "Approve Successful": "Approve Successful",
  "Created Successfully": "Created Successfully",
  "Update Successful": "Update Successful",
  "Delete Successful": "Delete Successful",
  "Leave Successful": "Leave Successful",
  "Join Successful": "Join Successful",
  "Approved Successfully": "Approved Successfully",
  "Rejected Successfully": "Rejected Successfully",
  "Message moved to inbox successfully": "Message moved to inbox successfully",
  "Message saved as draft successfully": "Message saved as draft successfully",
  "Message moved to trash successfully": "Message moved to trash successfully",
  "Message starred successfully": "Message starred successfully",
  "Error": "Error",
  "Something went wrong": "Something went wrong!",
  "Are you sure you want to continue": "Are you sure you want to continue",
  "Are you sure you want to delete": "Are you sure you want to delete",
  "Are you sure you want to leave": "Are you sure you want to leave",
  "Are you sure you want to join": "Are you sure you want to join",
  "Are you sure you want to join {eventName} event on {eventDate}?": "Are you sure you want to join <b>'{{eventName}}'</b> Event on <b>{{eventDate}}</b>?",
  "Are you sure you want to join {eventName} for all upcoming events?": "Are you sure you want to join <b>'{{eventName}}'</b> for all upcoming events?",
  "Are you sure you want to join {eventName} event on selected dates?": "Are you sure you want to join <b>'{{eventName}}'</b> event on selected dates?",
  "Your current Request is waiting for the Approval": "Your current Request is waiting for the Approval.",
  "Current Request is waiting for the Approval by Admin": "Current Request is waiting for the Approval by Admin.",
  "Current request has been denied": "Current request has been denied.",
  "Your current request is Rejected": "Your current request is Rejected.",
  "Your current request is Approved": "Your current request is Approved.",
  "Deny Reason": "Deny Reason",
  "Your current Request is waiting for the Approval by Admin": "Your current Request is waiting for the Approval by Admin.",
  "Your current request is Denied by Admin": "Your current request is Denied by Admin.",
  "Your update request is waiting for the approval by Admin": "Your update request is waiting for the approval by Admin",
  "Update request is waiting for the approval": "Update request is waiting for the approval",
  "You have unsaved changes. Are you sure you want to leave": "You have unsaved changes. Are you sure you want to leave",
  "confirmationDivider": "--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------",
  "Are you sure you want to accept this": "Are you sure you want to accept this ",
  "Are you sure you want to deny this": "Are you sure you want to deny this ",
  "Are you sure you want to approve this": "Are you sure you want to approve this ",
  "Are you sure you want to reject this": "Are you sure you want to reject this ",
  "Are you sure you want to unapprove this": "Are you sure you want to unapprove this ",
  "Are you sure you want to accept this Course": "Are you sure you want to accept this Course",
  "Are you sure you want to deny this Course": "Are you sure you want to deny this Course",
  "Are you sure you want to approve this Course": "Are you sure you want to approve this Course",
  "Are you sure you want to reject this Course": "Are you sure you want to reject this Course",
  "Are you sure you want to unapprove this Course": "Are you sure you want to unapprove this Course",
  "Are you sure you want to accept this Event": "Are you sure you want to accept this Event",
  "Are you sure you want to deny this Event": "Are you sure you want to deny this Event",
  "Are you sure you want to approve this Event": "Are you sure you want to approve this Event",
  "Are you sure you want to reject this Event": "Are you sure you want to reject this Event",
  "Are you sure you want to unapprove this Event": "Are you sure you want to unapprove this Event",
  "Are you sure you want to accept this News": "Are you sure you want to accept this News",
  "Are you sure you want to deny this News": "Are you sure you want to deny this News",
  "Are you sure you want to approve this News": "Are you sure you want to approve this News",
  "Are you sure you want to reject this News": "Are you sure you want to reject this News",
  "Are you sure you want to unapprove this News": "Are you sure you want to unapprove this News",
  "Are you sure you want to accept this Task": "Are you sure you want to accept this Task",
  "Are you sure you want to deny this Task": "Are you sure you want to deny this Task",
  "Are you sure you want to approve this Task": "Are you sure you want to approve this Task",
  "Are you sure you want to reject this Task": "Are you sure you want to reject this Task",
  "Are you sure you want to unapprove this Task": "Are you sure you want to unapprove this Task",
  "Are you sure you want to accept this Group": "Are you sure you want to accept this Group",
  "Are you sure you want to deny this Group": "Are you sure you want to deny this Group",
  "Are you sure you want to approve this Group": "Are you sure you want to approve this Group",
  "Are you sure you want to reject this Group": "Are you sure you want to reject this Group",
  "Are you sure you want to unapprove this Group": "Are you sure you want to unapprove this Group",
  "Are you sure you want to accept this FAQ": "Are you sure you want to accept this FAQ",
  "Are you sure you want to deny this FAQ": "Are you sure you want to deny this FAQ",
  "Are you sure you want to approve this FAQ": "Are you sure you want to approve this FAQ",
  "Are you sure you want to reject this FAQ": "Are you sure you want to reject this FAQ",
  "Are you sure you want to unapprove this FAQ": "Are you sure you want to unapprove this FAQ",
  "Are you sure you want to accept this Instructor": "Are you sure you want to accept this Instructor",
  "Are you sure you want to deny this Instructor": "Are you sure you want to deny this Instructor",
  "Are you sure you want to approve this Instructor": "Are you sure you want to approve this Instructor",
  "Are you sure you want to reject this Instructor": "Are you sure you want to reject this Instructor",
  "Are you sure you want to unapprove this Instructor": "Are you sure you want to unapprove this Instructor",
  "Are you sure you want to accept this Room": "Are you sure you want to accept this Room",
  "Are you sure you want to deny this Room": "Are you sure you want to deny this Room",
  "Are you sure you want to approve this Room": "Are you sure you want to approve this Room",
  "Are you sure you want to reject this Room": "Are you sure you want to reject this Room",
  "Are you sure you want to unapprove this Room": "Are you sure you want to unapprove this Room",
  "Are you sure you want to accept this Survey": "Are you sure you want to accept this Survey",
  "Are you sure you want to deny this Survey": "Are you sure you want to deny this Survey",
  "Are you sure you want to approve this Survey": "Are you sure you want to approve this Survey",
  "Are you sure you want to reject this Survey": "Are you sure you want to reject this Survey",
  "Are you sure you want to unapprove this Survey": "Are you sure you want to unapprove this Survey",
  "Are you sure you want to delete all shifts for": "Are you sure you want to delete all shifts for",
  "Are you sure you want to move this to trash": "Are you sure you want to move this to trash",
  "Are you sure you want to permanently delete this": "Are you sure you want to permanently delete this",
  "Are you sure you want to approve this join request": "Are you sure you want to approve this join request",
  "Are you sure you want to delete this image": "Are you sure you want to delete this image",
  "Are you sure you want to delete this document": "Are you sure you want to delete this document",
  "Are you sure you want to complete this task": "Are you sure you want to complete this task",
  "payment information": "payment information",
  "Android App": "Android App",
  "iOS App": "iOS App",
  "Club Surveys": "Club Surveys",
  "Active Polls": "Active polls",
  "My Polls": "My polls",
  "Completed Polls": "Completed polls",
  "Completed Surveys": "Completed surveys",
  "Opinion Poll": "Opinion poll",
  "owner": "Owner",
  "Active on": "Active on",
  "Active from": "Active from",
  "Expired on": "Expired on",
  "remaining time": "Remaining time",
  "status": "Status",
  "Change Password": "Change Password",
  "Add Survey": "Add Survey",
  "View Survey": "View Survey",
  "Delete Survey": "Delete Survey",
  "Active Survey": "Active Survey",
  "Close Survey": "Close Survey",
  "Survey Activated Successfully": "Survey activated successfully",
  "Survey Closed Successfully": "Survey closed successfully",
  "Survey Close Confirmation": "Survey Close Confirmation",
  "Survey Active Confirmation": "Survey Active Confirmation",
  "Are you sure you want to active": "Are you sure you want to active",
  "Are you sure you want to close": "Are you sure you want to close",
  "Leave": "Leave",
  "Edit": "Edit",
  "Delete": "Delete",
  "Remove": "Remove",
  "Add": "Add",
  "Create": "Create",
  "Save": "Save",
  "Update": "Update",
  "update": "Update",
  "Cancel": "Cancel",
  "Back": "Back",
  "accept": "Accept",
  "Accept": "Accept",
  "Decline": "Decline",
  "deny": "Deny",
  "Deny": "Deny",
  "view": "View",
  "View": "View",
  "view survey": "View Survey",
  "view task": "View Task",
  "View Task": "View Task",
  "Drag and drop image here, or click to add image": "Drag and drop image here, or click to add image",
  "Drag and drop image here, or click to change image": "Drag and drop image here, or click to change image",
  "Drag and drop file here, or click to add file": "Drag and drop file here, or click to add file",
  "Drag and drop file here, or click to change file": "Drag and drop file here, or click to change file",
  "Add Image": "Add Image",
  "Add File": "Add File",
  "Change Image": "Change Image",
  "View more": "View more",
  "Notifications": "Notifications",
  "See more Notifications": "See more notifications",
  "Title": "Title",
  "Start Date": "Start Date",
  "End Date": "End Date",
  "New Survey": "New Survey",
  "Survey Edit": "Survey Edit",
  "Survey Details": "Survey Details",
  "Survey": "Survey",
  "Question": "Question",
  "Single selection": "Single selection",
  "Multiple selection": "Multiple selection",
  "Add Choice": "Add Choice",
  "Enter your question": "Enter your question",
  "Publish": "Publish",
  "Add Question": "Add Question",
  "Enter your survey name": "Enter your survey name",
  "Assigned tasks": "Assigned tasks",
  "About event": "About event",
  "Event details": "Event Details",
  "Clear All": "Clear All",
  "Select Date": "Select Date",
  "Delete Banner": "Delete Banner",
  "Banner": "Banner",
  "Banners": "Banners",
  "Logo": "Logo",
  "Footer": "Footer",
  "Email Type": "Email Type",
  "Subject": "Subject",
  "To": "To",
  "Cc": "Cc",
  "Recipients": "Recipients",
  "Edit Draft Message": "Edit Draft Message",
  "Header Content": "Header Content",
  "Template Body": "Template Body",
  "Footer Content": "Footer Content",
  "Url": "URL",
  "Action": "Action",
  "Thumbnail": "Thumbnail",
  "From": "From",
  "Template Type": "Template Type",
  "Header Subject": "Header Subject",
  "Email Template": "E-mail Template",
  "Create Email Template": "Create Email Template",
  "Content": "Content",
  "instructor": "Instructor",
  "survey": "Survey",
  "course": "Course",
  "updatedcourse": "Updated Course",
  "Select Option": "Select Option",
  "Select Options": "Select Options",
  "Tag": "Tag",
  "Tags": "Tags",
  "Tag Name": "Tag Name",
  "Create Tag": "Create Tag",
  "Instructor Tag Name": "Instructor Tag Name",
  "Room Tag Name": "Room Tag Name",
  "Courses": "Courses",
  "Instructor": "Instructor",
  "Room": "Room",
  "Rooms": "Rooms",
  "New Tag": "New Tag",
  "Task": "Task",
  "task": "Task",
  "Event": "Event",
  "Events": "Events",
  "Event Name": "Event Name",
  "Event Type": "Event Type",
  "FAQs": "FAQs",
  "Surveys": "Surveys",
  "News": "News",
  "news": "News",
  "news posts": "News Posts",
  "news post": "News Post",
  "create news post": "Create News Post",
  "edit news post": "Edit News Post",
  "news post details": "News Post Details",
  "discover": "Discover",
  "create news": "Create News",
  "news from the groups": "News from the groups",
  "No Available Content": "No Available Content",
  "re you sure you want to delete this Tag?": "re you sure you want to delete this Tag?",
  "Update Tag": "Update Tag",
  "Add task": "Add Task",
  "Tasks": "Tasks",
  "Task details": "Task Details",
  "Create task": "Create Task",
  "Edit task": "Edit Task",
  "All tasks": "All Tasks",
  "My tasks": "My Tasks",
  "Completed tasks": "Completed Tasks",
  "Open tasks": "Open Tasks",
  "Group tasks": "Group Tasks",
  "New task": "New Task",
  "Subtasks": "Sub Tasks",
  "Add Sub-task": "Add sub-task",
  "Select date": "Select Date",
  "Select Time": "Select Time",
  "ToDo": "To-Do",
  "In-Progress": "In-Progress",
  "InProgress": "In-Progress",
  "Completed": "Completed",
  "Comments": "Comments",
  "Assigned": "Assigned",
  "Assign to": "Assign to",
  "Add a Card": "Add a card",
  "Add Card": "Add Card",
  "Add element": "Add Element",
  "Enter a title for this card": "Enter a title for this card",
  "Tasks to be completed": "Task to be completed",
  "Group": "Group",
  "Individual": "Individual",
  "Task type": "Task Type",
  "Add Tag": "Add Tag",
  "Enter Title": "Enter Title",
  "Enter Description": "Enter Description",
  "Select": "Select",
  "News Posts": "News Posts",
  "Posts": "Posts",
  "Message Chats": "Message Chats",
  "Message": "Message",
  "Chats": "Chats",
  "Tasks Events": "Tasks Events",
  "news from the club": "News from the club",
  "News from the group": "News from the group",
  "News from the Company": "News from the Company",
  "Current club dates": "Current club dates",
  "Current company dates": "Current company dates",
  "Participant": "Participant",
  "Read more": "Read more",
  "Clock": "Clock",
  "Popular": "Popular",
  "Latest": "Latest",
  "Available Tasks": "Available Tasks",
  "Available": "Available",
  "New": "New",
  "No News": "No News",
  "Menu": "Menu",
  "Answer Options": "Answer Options",
  "Enter answer choice": "Enter answer choice",
  "Answer": "Answer",
  "Survey Type": "Survey Type",
  "Type": "Type",
  "View Options": "View Options",
  "Notification": "Notification",
  "Anonymous Voting": "Anonymous Voting",
  "Allow Correcting the Cast Vote": "Allow Correcting the Cast Vote",
  "Multiple Choice": "Multiple Choice",
  "Single Choice": "Single Choice",
  "Web Notification": "Web Notification",
  "Email Notification": "Email Notification",
  "Always": "Always",
  "After Voting": "After Voting",
  "Never": "Never",
  "All Club": "All Club",
  "All Important Dates": "All Important Dates",
  "Jubilees": "Jubilees",
  "Birthdays": "Birthdays",
  "Anniversary": "Anniversary",
  "Birthday": "Birthday",
  "days ago": "days ago",
  "days left": "days left",
  "years": "years",
  "years in club": "years in club",
  "Today": "Today",
  "Today is": "Today is",
  "No upcoming birthdays or anniversaries": "No upcoming birthdays or anniversaries",
  "Say Congrats": "Say Congrats",
  "Reply": "Reply",
  "Reply All": "Reply All",
  "Forward": "Forward",
  "No Messages": "No Messages",
  "All Events": "All Events",
  "Club Event": "Club Events",
  "Group Event": "Group Event",
  "Functionaries Event": "Functionaries Event",
  "Course": "Course",
  "Seminar": "Seminar",
  "Items Per Page": "Items Per Page",
  "Description": "Description",
  "Enter to search": "Enter to search",
  "New Chat": "New Chat",
  "New Email": "New Email",
  "Email": "Email",
  "E-Mail": "Email",
  "Select an email to start communication": "Select an email to start communication",
  "Select a chat to start messaging": "Select a chat to start messaging",
  "Looks like you haven’t initiated a conversation with any of your team members": "Looks like you haven’t initiated a conversation with any of your team members",
  "Enter your survey description": "Enter your survey description",
  "Manage members and set their access level in your workspace": "Manage members and set their access level in your workspace",
  "New Message": "New Message",
  "Message Type": "Message Type",
  "Add a subject...": "Add a subject...",
  "Select A Message": "Select A Message",
  "Choose File": "Choose File",
  "Change File": "Change File",
  "Type a message...": "Type a message...",
  "Draft": "Draft",
  "Drafts": "Drafts",
  "Send": "Send",
  "Bin": "Bin",
  "All Messages": "All Messages",
  "Posted": "Posted",
  "Marked": "Marked",
  "Inbox": "Inbox",
  "Trash": "Trash",
  "Starred": "Starred",
  "Sent": "Sent",
  "All Mails": "All Messages",
  "Personal": "Personal",
  "Sorting": "Sorting",
  "Active Member": "Active Member",
  "Membership number": "Membership number",
  "In the team since": "In the team since",
  "In the club since": "In the club since",
  "Category": "Category",
  "Position": "Position",
  "Category Name": "Category Name",
  "Select Language": "Select Language",
  "Select Theme": "Select Theme",
  "No record found": "No record found",
  "No items available": "No items available",
  "No tags available": "No tags available",
  "Internal": "Internal",
  "External": "External",
  "Booked Out": "Booked Out",
  "Internal Instructor": "Internal Instructor",
  "External Instructor": "External Instructor",
  "Instructor Type": "Instructor Type",
  "Faq Category": "Faq Category",
  "Faq Category Name": "Faq Category Name",
  "Sort and Filter": "Sort and Filter",
  "Clear": "Clear",
  "Select Tags": "Select Tags",
  "Name of the Event": "Name of the Event",
  "Venue": "Venue",
  "Add Venue": "Add Venue",
  "No venue available": "No venue available",
  "Event Venues": "Event Venues",
  "Create Event Venue": "Create Event Venue",
  "Event Venue Name": "Event Venue Name",
  "Event Types": "Event Types",
  "Visibility of Event": "Visibility of Event",
  "Show Guests": "Show Guests",
  "Chargeable": "Chargeable",
  "Additional Features": "Additional Features",
  "Event Price": "Event Price",
  "Assign a task to an event": "Assign a task to an event",
  "Task Description": "Task Description",
  "Task Types": "Task Types",
  "Week Days": "Week Days",
  "Recurrence": "Recurrence",
  "Start Time": "Start Time",
  "End Time": "End Time",
  "Event Date": "Event Date",
  "Event Time": "Event Time",
  "Room No (optional)": "Room No (optional)",
  "Repeat Event": "Repeat Event",
  "Image": "Image",
  "Enter Price": "Enter Price",
  "Time From": "Time From",
  "Time To": "Time To",
  "Every": "Every",
  "Days": "Days",
  "Weeks": "Weeks",
  "Months": "Months",
  "Years": "Years",
  "Day": "Day",
  "Repeat Daily": "Repeat Daily",
  "Repeat Weekly": "Repeat Weekly",
  "Repeat Monthly": "Repeat Monthly",
  "Repeat Yearly": "Repeat Yearly",
  "Public": "Public",
  "Private": "Private",
  "Club": "Club",
  "Clubs": "Clubs",
  "Company": "Company",
  "Does Not Repeat": "Does not repeat",
  "Every Day": "Every Day",
  "Every Week": "Every Week",
  "Every Month": "Every Month",
  "Every Year": "Every Year",
  "Custom": "Custom",
  "Club  Event": "Club Event",
  "Select Participants": "Select Participants",
  "Participants": "Participants",
  "Private Group": "Private Group",
  "Course Information": "Course Information",
  "Place": "Place",
  "Date": "Date",
  "Time": "Time",
  "Instructor Name": "Instructor Name",
  "Available Times": "Available Times",
  "Qualification": "Qualification",
  "More Courses": "More Courses",
  "Theme": "Theme",
  "Room Information": "Room Information",
  "Task Details": "Task Details",
  "Assignment": "Assignment",
  "Due Date": "Due Date",
  "Room Details": "Room Details",
  "Address": "Address",
  "People": "People",
  "Pending": "Pending",
  "Approved": "Approved",
  "Room Info": "Room Info",
  "To be submitted at the of course": "To be submitted at the of course",
  "Add Course": "Add Course",
  "Add Location": "Add Location",
  "Add Tags": "Add Tags",
  "Course Date": "Course Date",
  "Allowed Persons": "Allowed Persons",
  "Add a Title": "Add a Title",
  "Headline": "Headline",
  "Types": "Types",
  "Enter headline": "Enter headline",
  "Enter content": "Enter content",
  "News Highlight": "News Highlight",
  "Club News": "Club News",
  "Company News": "Company News",
  "New from the club": "New from the club",
  "New Posts": "New Posts",
  "Task Events": "Task Events",
  "Delete Group": "Delete Group",
  "Groups": "Groups",
  "Group Details": "Group Details",
  "Leave Group": "Leave Group",
  "Join Group": "Join Group",
  "Group Name": "Group Name",
  "Course Name": "Course Name",
  "Visibility": "Visibility",
  "No file chosen": "No file chosen",
  "Assign a task to course": "Assign a task to course",
  "Please fill all required fields": "Please fill all required fields",
  "Room Availability": "Room Availability",
  "Room Capacity": "Room Capacity",
  "Room Charges": "Room Charges",
  "Room Current Bookings": "Room Current Bookings",
  "Instructor Availability": "Instructor Availability",
  "Instructor Current Bookings": "Instructor Current Bookings",
  "Instructor not available for the following dates and times": "Instructor not available for the following dates and times",
  "Room not available for the following dates and times": "Room not available for the following dates and times",
  "Not within availability": "Not within availability",
  "Add News": "Add News",
  "Waiting for Approval": "Waiting for Approval",
  "Survey Results": "Survey Results",
  "Survey Results Details": "Survey Results Details",
  "Survey Created By": "Survey Created By",
  "Survey Has been Closed": "Survey Has been Closed",
  "You've not voted": "You've not voted",
  "My Vote": "My Vote",
  "To Vote": "To Vote",
  "My Vote: You can select Multiple Options": "My Vote: You can select Multiple Options",
  "My Vote: You can select only one option": " My Vote: You can select only one option",
  "Following people has voted For this option:": "Following people has voted For this option:",
  "Total Number of Votes for this Option:": "Total Number of Votes for this Option:",
  "Are you sure you want to complete this": "Are you sure you want to complete this",
  "Please complete all subtasks before marking the task as completed": "Please complete all subtasks before marking the task as completed",
  "Mark subtask as complete to move task to In Progress": "Mark subtask as complete to move task to In Progress",
  "wants to join a Group": "wants to join a Group",
  "wants to publish an updated Group": "wants to publish an updated Group",
  "has updated the Group": "has updated the Group",
  "invited you to": "invited you to",
  "wants to publish a Group": "wants to publish a Group",
  "has denied the Group": "has denied the Group",
  "has been added to the Group": "has been added to the Group",
  "has published the Group": "has published the Group",
  "wants to publish a News": "wants to publish a News",
  "wants to publish an updated News": "wants to publish an updated News",
  "has denied the News": "has denied the News",
  "has published the News": "has published the News",
  "has updated the News": "has updated the News",
  "wants to publish an Event": "wants to publish an Event",
  "wants to publish an updated Event": "wants to publish an updated Event",
  "has denied the Event": "has denied the Event",
  "has published the Event": "has published the Event",
  "has updated the Event": "has updated the Event",
  "invited you to an Event": "invited you to an Event",
  "has updated Event for existing users": "has updated Event for existing users",
  "has updated Course for existing users": "has updated Course for existing users",
  "wants to publish a Course": "wants to publish a Course",
  "wants to publish an updated Course": "wants to publish an updated Course",
  "wants to join a Course you have created": "wants to join a Course you have created",
  "has been added to a Course by the creator": "has been added to a Course by the creator",
  "invited you to a Course": "invited you to a Course",
  "wants to assign Instructor to a Course": "wants to assign Instructor to a Course",
  "wants to update assigned Instructor of a Course": "wants to update assigned Instructor of a Course",
  "has published the Course": "has published the Course",
  "has updated the Course": "has updated the Course",
  "has denied the Course": "has denied the Course",
  "invited you to a Task": "invited you to a Task",
  "wants to publish a Task": "wants to publish a Task",
  "wants to publish an updated Task": "wants to publish an updated Task",
  "has unapproved the Task": "has unapproved the Task",
  "has unapproved the Subtask": "has unapproved the Subtask",
  "has denied the Task": "has denied the Task",
  "has published the Task": "has published the Task",
  "has updated the Task": "has updated the Task",
  "has completed the Task": "has completed the Task",
  "has sent you a message": "has sent you a message",
  "wants to publish a Survey": "wants to publish a Survey",
  "wants to publish an updated Survey": "wants to publish an updated Survey",
  "has invited you to participate in a Survey": "has invited you to participate in a Survey",
  "has published the Survey": "has published the Survey",
  "has updated the Survey": "has updated the Survey",
  "has denied the Survey": "has denied the Survey",
  "wants to publish a Room": "wants to publish a Room",
  "wants to publish an updated Room": "wants to publish an updated Room",
  "has published the Room": "has published the Room",
  "has updated the Room": "has updated the Room",
  "has denied the Room": "has denied the Room",
  "wants to publish an Instructor": "wants to publish an Instructor",
  "wants to publish an updated Instructor": "wants to publish an updated Instructor",
  "has denied the Instructor": "has denied the Instructor",
  "has published the Instructor": "has published the Instructor",
  "has updated the Instructor": "has updated the Instructor",
  "wants to publish an FAQ": "wants to publish an FAQ",
  "wants to publish an updated FAQ": "wants to publish an updated FAQ",
  "has published the FAQ": "has published the FAQ",
  "wants to publish an updated FAQ to author": "wants to publish an updated FAQ to author",
  "has denied the FAQ to author": "has denied the FAQ to author",
  "wants to publish an FAQ category": "wants to publish an FAQ category",
  "Unknown notification type": "Unknown notification type",
  "Occupancy": "Occupancy",
  "Free": "Free",
  "Calendar": "Calendar",
  "Jan": "Jan",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Apr",
  "May": "May",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Aug",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Dec",
  "mo": "Mo",
  "tu": "Tu",
  "we": "We",
  "th": "Th",
  "fr": "Fr",
  "sa": "Sa",
  "su": "Su",
  "mo 1": "M",
  "tu 1": "T",
  "we 1": "W",
  "th 1": "T",
  "fr 1": "F",
  "sa 1": "S",
  "su 1": "S",
  "current": "Current",
  "all": "All",
  "monday": "Monday",
  "tuesday": "Tuesday",
  "wednesday": "Wednesday",
  "thursday": "Thursday",
  "friday": "Friday",
  "saturday": "Saturday",
  "sunday": "Sunday",
  "january": "January",
  "february": "February",
  "march": "March",
  "april": "April",
  "may": "May",
  "june": "June",
  "july": "July",
  "august": "August",
  "september": "September",
  "october": "October",
  "november": "November",
  "december": "December",
  "just now": "just now",
  "a minute ago": "a minute ago",
  "minutes ago": "minutes ago",
  "an hour ago": "an hour ago",
  "hours ago": "hours ago",
  "yesterday": "yesterday",
  "a week ago": "a week ago",
  "weeks ago": "weeks ago",
  "Click to download": "Click to download",
  "Click to preview": "Click to preview",
  "other": "Other",
  "Members": "Members",
  "Search Filter": "Search Filter",
  "Search": "Search",
  "Search Results": "Search Results",
  "Last Active": "Last Active",
  "Status": "Status",
  "Role": "Role",
  "Online": "Online",
  "Offline": "Offline",
  "List": "List",
  "Members List": "Members List",
  "Created": "Created",
  "Paid": "Paid",
  "Unpaid": "Unpaid",
  "Active": "Active",
  "Inactive": "Inactive",
  "Apply Filter": "Apply Filter",
  "Anonymous": "Anonymous",
  "Show hidden events": "Show hidden events",
  "Hide Event": "Hide Event",
  "UnHide Event": "UnHide Event",
  "Banner Placement": "Banner Placement",
  "Banner Display Tags": "Banner Display Tags",
  "Create New Tag": "Create New Tag",
  "Task Type": "Task Type",
  "Leave Event": "Leave Event",
  "Join Event": "Join Event",
  "Join This Event": "Join This Event",
  "Join All Events in Series": "Join All Events in Series",
  "Join Event on Specific Dates": "Join Event on Specific Dates",
  "Accept event": "Accept event",
  "Deny event": "Deny event",
  "Publish event": "Publish event",
  "Event Members": "Event Members",
  "Event Tasks": "Event Tasks",
  "Event Details": "Event Details",
  "About group": "About group",
  "Show more": "Show more",
  "Your team": "Your team",
  "Responsible": "Responsible",
  "Collaborators": "Collaborators",
  "Work Shifts": "Work Shifts",
  "Create Work Shift": "Create Work Shift",
  "NO Of Shifts": "No. Of Shifts",
  "No Shifts Data found": "No Shifts Data found",
  "Error while fetching Shifts Details": "Error while fetching Shifts Details",
  "Shift": "Shift",
  "Form": "Form",
  "No new notifications": "No new notifications",
  "No Data": "No Data",
  "Add Work-shifts to an event": "Add Work-shifts to an event",
  "Click to open details": "Click to open details",
  "permanently": "permanently",
  "Folder": "Folder",
  "Star Message": "Star Message",
  "Unstar Message": "Unstar Message",
  "Impressum": "Legal Disclosure",
  "Terms and Conditions": "Terms and Conditions",
  "Terms of Use": "Terms of Use",
  "Privacy Policy": "Privacy Policy",
  "You can find our applicable documents here": "You can find our applicable documents here",
  "Club Administration": "Club Administration",
  "Financial Accounting": "Financial Accounting",
  "License & More": "License & More",
  "Documents": "Documents",
  "Current Statuses": "Current Statuses",
  "Corporate Philosophy": "Corporate Philosophy",
  "Corporate": "Corporate",
  "Archive": "Archived",
  "All": "All",
  "Tables": "Tables",
  "Images": "Images",
  "Delete File": "Delete File",
  "Download File": "Download File",
  "Preview Image": "Preview Image",
  "Upload Document": "Upload Document",
  "Move to My Documents": "Move to My Documents",
  "Move to Archived": "Move to Archived",
  "Move to Current Statuses": "Move to Current Statuses",
  "Move to CLub Documents": "Move to Club Documents",
  "Move to Corporate Philosophy": "Move to Corporate Philosophy",
  "Move to Corporate Documents": "Move to Corporate Documents",
  "Ascending": "Ascending",
  "Descending": "Descending",
  "Order By": "Order By",
  "Order": "Order",
  "date": "Date",
  "name": "Name",
  "Are you sure you want to move": "Are you sure you want to move",
  "Document moved successfully": "Document moved successfully",
  "Only PDF files are allowed in Current Statuses": "Only PDF files are allowed in Current Statuses",
  "Upload Successful": "Upload Successful",
  "Profile": "Profile",
  "Attachment": "Attachment",
  "Download Attachment": "Download Attachment",
  "Author": "Author",
  "CRM Surveys": "CRM Surveys",
  "CRM Survey": "CRM Survey",
  "Voting Results": "Voting Results",
  "Votes": "Votes",
  "Total Votes": "Total Votes",
  "Close": "Close",
  "Thank you for your vote": "Thank you for your vote",
  "By": "By",
  "CRM News": "CRM News",
  "Read": "Read",
  "Mark all notifications as read": "Mark all notifications as read",
  "Close this notification": "Close this notification",
  "Phone": "Phone",
  "Published by": "Published by",
  "Deleted User": "Deleted User",
  "Delete Chat": "Delete Chat",
  "Availability": "Availability",
  "Availability locked due to bookings.": "Availability locked due to bookings.",
  "Enter Name": "Enter Name",
  "Enter Email": "Enter Email",
  "Phone No": "Phone No",
  "Enter Phone No": "Enter Phone No",
  "Enter Address": "Enter Address",
  "No Of Persons": "No Of Persons",
  "Enter No Of Persons": "Enter No Of Persons",
  "Price": "Price",
  "First Name": "First Name",
  "Enter First Name": "Enter First Name",
  "Last Name": "Last Name",
  "Enter Last Name": "Enter Last Name",
  "Enter Qualification": "Enter Qualification",
  "Repeat Course": "Repeat Course",
  "Delete Selected": "Delete Selected",
  "Deselect All": "Deselect All",
  "Statistics": "Statistics",
  "Clicks": "Clicks",
  "Banner Statistics": "Banner Statistics",
  "Banner Desktop Clicks": "Banner Desktop Clicks",
  "Select Admin": "Select Admin",
  "Group Chat": "Group Chat",
  "Groupchat": "Group Chat",
  "Personal Chat": "Personal Chat",
  "Created By": "Created By",
  "Invoice": "Invoice",
  "Profile Image": "Profile Image",
  "Share Birthday": "Share birthday",
  "Allow Advertisement": "Allow Advertisement",
  "Date From": "Date From",
  "Date To": "Date To",
  "m ago": "{{count}} minute(s) ago",
  "h ago": "{{count}} hour(s) ago",
  "d ago": "{{count}} day(s) ago",
  "w ago": "{{count}} week(s) ago",
  "mo ago": "{{count}} month(s) ago",
  "Completed Subtasks": "Completed Subtasks",
  "Total Subtasks": "Total Subtasks",
  "Task Assigned to": "Task Assigned to",
  "To be done by": "To be done by",
  "This Task Only Completed by Admin, Organizer and Collaborators of this Task": "This Task Only Completed by Admin, Organizer and Collaborators of this Task",
  "You do not have permission to complete this subtask, only participants of this Task & Subtasks, organizer of this task, and Administrator can complete this subtask": "You do not have permission to complete this subtask, only participants of this Task & Subtasks, organizer of this task, and Administrator can complete this subtask",
  "Free Space": "Free Space",
  "Desktop": "Web",
  "Notification Section": "Notification section",
  "Everywhere": "Everywhere",
  "Welcome to your club community!": "Welcome to your club community!",
  "Stay networked with your club, exchange ideas and organize everything in one place.": "Stay networked with your club, exchange ideas and organize everything in one place.",
  "Everything you need for your club - in one place.": "Everything you need for your club - in one place.",
  "Simply register, contact members, plan appointments and achieve more together.": "Simply register, contact members, plan appointments and achieve more together.",
  "Stay connected - anytime, anywhere.": "Stay connected - anytime, anywhere.",
  "Access important information, share news and collaborate with your team.": "Access important information, share news and collaborate with your team.",
  "Happy Birthday": "Happy Birthday",
  "Happy Anniversary": "Happy Anniversary",
  "Instant and uncomplicated chatting with members or groups": "Instant and uncomplicated chatting with members or groups",
  "Your own mailbox based on the classic e-mail": "Your own mailbox based on the classic e-mail",
  "Invalid file type or size. Only PNG, JPEG images and allowed documents under 10MB are allowed": "Invalid file type or size. Only PNG, JPEG images and allowed documents under 10MB are allowed",
  "Club Overview": "Club Overview",
  "Happenings": "Happenings",
  "Occasions": "Occasions",
  "No:": "No:",
  "Password changed successfully. Please login again": "Password changed successfully. Please login again",
  "This is a private group. You need to request to join this group": "This is a private group. You need to request to join this group",
  "Your request to join this group is pending": "Your request to join this group is pending",
  "Your request to join this group has been rejected": "Your request to join this group has been rejected",
  "Confirm Delete": "Confirm Delete",
  "No news has been created in the club yet": "No news has been created in the club yet",
  "No news has been created in any Group yet": "No news has been created in any Group yet",
  "No group has been created in the club yet": "No group has been created in the club yet",
  "No events available": "No events available",
  "Additional address": "Additional address",
  "You have no notifications": "You have no notifications",
  "Information about the course": "Information about the course",
  "Further information about the course": "Further information about the course",
  "Invite Participants": "Invite Participants",
  "Select all": "Select all",
  "Unselect all": "Unselect all",
  "Done": "Done",
  "You already have a pending change request": "You already have a pending change request",
  "Messages": "Messages",
  "Calendar view": "Calendar view",
  "Card view": "Card view",
  "Mark As Complete": "Mark as Complete",
  "No Bookings": "No Bookings",
  "Schedule view": "Schedule view",
  "Hide Empty Slots": "Hide Empty Slots",
  "Group Filter": "Group Filter",
  "No Conversation": "No Conversation",
  "Select Event Dates": "Select Event Dates",
  "Select the dates you want to join for this event": "Select the dates you want to join for this event",
  "Join Selected Dates": "Join Selected Dates",
  "Selected": "Selected",
  "dates": "dates",
  "new": "new",
  "Please select at least one new date": "Please select at least one new date",
  "No available dates for this event": "No available dates for this event",
  "Accept This Event": "Accept This Event",
  "Accept All Events in Series": "Accept All Events in Series",
  "Accept Event on Specific Dates": "Accept Event on Specific Dates",
  "DIVIDER": "-------------------------------------------------------------DIVIDER---------------------------------------------------------------------",
  "formErrors": {
    "is required.": "is required.",
    "is invalid.": "is invalid.",
    "is required to be at least": "is required to be at least",
    "cannot be longer than": "cannot be longer than",
    "can't be greater than": "can't be greater than",
    "can't be less than": "can't be less than",
    "must contain at least 1 in Capital Case!": "must contain at least 1 in Capital Case!",
    "must contain at least 1 Letter in Small Case!": "must contain at least 1 Letter in Small Case!",
    "must contain at least 1 Special Character!": "must contain at least 1 Special Character!",
    "do not match.": "do not match.",
    "must be unique.": "must be unique.",
    "must be greater than 0.": "must be greater than 0.",
    "must be greater.": "must be greater.",
    "must be greater than or equal.": "must be greater than or equal.",
    "must be after the start date.": "must be after the start date.",
    "invalid pattern": "invalid pattern",
    "invalid pattern, 12345-1234 or 12345": "invalid pattern, 12345-1234 or 12345"
  },
  "loginForm": {
    "Login into your account": "Login into your account",
    "Username": "Username",
    "Password": "Password",
    "Remember me": "Remember me",
    "I forgot my password": "I forgot my password",
    "Don't have an account?": "Don't have an account?",
    "Login": "Login",
    "Sign up for Verein.cloud": "Sign up for verein.cloud®",
    "Password (6+ characters)": "Password (6+ characters)"
  },
  "buttonComponent": {
    "Login": "Login",
    "Success": "Success",
    "Save": "Save",
    "Processing": "Processing",
    "Error": "Error",
    "Cancel": "Cancel",
    "done": "Done",
    "Join Event": "Join event",
    "Leave Event": "Leave event"
  },
  "header": {
    "open": "Open",
    "close": "Close",
    "start typing": "Start typing..",
    "messages": "Messages"
  },
  "nav": {
    "event tasks": "Event Tasks",
    "event members": "Event Members",
    "create event form": "Create Event Form",
    "dashboard": "Dashboard",
    "news": "News",
    "clubWall": "Club Wall",
    "community": "Community",
    "organizer": "Organizer",
    "courses": "Courses",
    "tasks": "Tasks",
    "appointments": "Appointments",
    "task&appointments": "Tasks & Appointments",
    "events": "Events",
    "messages": "Messages",
    "messages&groups": "Messages & Groups",
    "settings": "Settings",
    "groups": "Groups",
    "academic": "Academic",
    "app store": "App Store",
    "my profile": "My Profile",
    "profile": "Profile",
    "club tools": "Club Tools",
    "marketing": "Marketing",
    "marketing tools": "Marketing Tools",
    "banners": "Banners",
    "create banner": "Create Banner",
    "create event": "Create Event",
    "emails": "Emails",
    "create email": "Create Email",
    "tags": "Tags",
    "survey": "Surveys",
    "course management": "Course Management",
    "club FAQs": "Club FAQs",
    "group details": "Group Details",
    "chat": "Chat",
    "events & club dates": "Events & Club Dates",
    "club addons": "Club Addons",
    "more": "More",
    "documents": "Documents",
    "add": "Add",
    "faq": "FAQ",
    "my content": "My Content"
  },
  "community": {
    "group overview": "Group Overview",
    "dashboard": "Dashboard",
    "community": "Community",
    "messages": "Messages",
    "groups": "Groups",
    "members": "Members",
    "open chat": "Open Chat",
    "leave": "Leave",
    "edit": "Edit",
    "delete": "Delete",
    "add": "Add",
    "create": "Create",
    "show all groups": "Show all groups",
    "groups you manage": "Groups you manage",
    "groups you are a member of": "Groups you're a member of"
  },
  "groups": {
    "groups": "Groups",
    "group": "Group",
    "group details": "Group Details",
    "group chat": "Group Chat",
    "members": "Members",
    "news": "News",
    "tasks": "Tasks",
    "events": "Events",
    "about": "About",
    "About this group": "About this group",
    "set": "Set",
    "your team": "Your team",
    "new": "New",
    "group admin": "Group admin",
    "age": "age",
    "no group": "No Group",
    "no event": "No Events",
    "no task": "No Tasks",
    "no news": "No News",
    "no member": "No Member",
    "join success message": "You have joined the group successfully.",
    "waiting admin approval": "Waiting for admin approval",
    "leave success message": "You have left the group successfully.",
    "delete success message": "Group deleted successfully."
  },
  "banners": {
    "link": "Link",
    "content": "Content",
    "description": "Description",
    "banner status": "Status",
    "update courses": "Update Courses",
    "banner invoice": "Invoice",
    "banner category": "Category",
    "banner categories": "Banner Categories",
    "banner images": "Banner Images",
    "add description": "Add Description",
    "create banner": "Create Banner",
    "thumbnail": "Thumbnail",
    "add image": "Add Image",
    "title": "Title",
    "sponsor": "Sponsor",
    "open space": "Open Space",
    "app sponsor": "App Sponsor",
    "group details": "Group Details",
    "all groups": "All Groups",
    "all news": "All News",
    "not paid": "Not Paid",
    "save": "Save",
    "cancel": "Cancel",
    "banner link": "Banner Link",
    "banner title": "Banner Title",
    "edit banner": "Edit Banner",
    "banner display": "Display",
    "news details": "News Details",
    "banner placement": "Placement",
    "banner display tag": "Banner Display Tag",
    "banner redirect link": "Redirect Link"
  },
  "dates&filters": {
    "date": "Date",
    "days": "Days",
    "day": "Day",
    "hour": "Hour",
    "hours": "Hours",
    "time": "Time",
    "year": "Year",
    "years": "Years",
    "month": "Month",
    "months": "Months",
    "week": "Week",
    "weeks": "Weeks",
    "opinion": "Opinion",
    "event type": "Event Type",
    "sort and filter": "Sort and Filter",
    "clear filters": "Clear Filters",
    "clear": "Clear",
    "expired": "Expired"
  },
  "messages": {
    "new group": "New group",
    "new chat": "New chat",
    "chat": "Chat",
    "personal": "Personal",
    "club": "Club",
    "group": "Group",
    "clubs": "Clubs",
    "members": "Member",
    "write a message": "Write a message",
    "media links and docs": "Media, Links and Docs",
    "group in common": "Group in common",
    "close": "Close",
    "group name": "Group name",
    "cancel": "Cancel",
    "save": "Save",
    "delete": "Delete",
    "report": "Report",
    "no messages yet": "No messages yet",
    "start the conversation": "Start the conversation"
  },
  "users": {
    "my profile": "My Profile",
    "user profile": "User Profile",
    "user": "User",
    "general information": "General Information",
    "my payment data": "My Payment Data",
    "association master data": "Association Master Data",
    "me at the club": "Me at the club",
    "I in the company": "I in the company",
    "my address information": "My Address Information",
    "communication data": "Communication Data",
    "street number": "Street Number",
    "more info": "More Info",
    "city": "City",
    "zip code": "Zip Code",
    "e-mail address": "E-mail Address",
    "phone number": "Phone Number",
    "date of birth": "Date Of Birth",
    "address supplement": "Address Supplement",
    "save profile": "Save Profile",
    "password information": "Password Information",
    "old password": "Old Password",
    "minimum 6 characters": "Minimum 6 characters",
    "change": "Change",
    "bank holder name": "Bank Holder Name",
    "iban": "IBAN",
    "bic": "BIC",
    "social links": "Social Links",
    "facebook": "Facebook",
    "twitter": "Twitter",
    "instagram": "Instagram",
    "homepage": "Homepage",
    "country": "Country",
    "bank name": "Bank Name",
    "member ship start date": "Membership Start Date",
    "My role in verein.cloud®": "My role in verein.cloud®"
  },
  "club_tools": {
    "create question": "Create question",
    "faq categories": "FAQ Categories",
    "start searching": "Start searching",
    "membership": "Membership",
    "maintenance and care": "Maintenance and care",
    "create faq": "Create Faq",
    "update faq": "Update Faq",
    "create title": "Create title",
    "add description here": "Add description here"
  },
  "courses": {
    "instructors": "Instructors",
    "rooms": "Rooms",
    "all instructors": "All Instructors",
    "all rooms": "All Rooms",
    "today": "Today",
    "upcoming": "Upcoming",
    "join": "Join",
    "joined": "Joined",
    "rejected": "Rejected",
    "persons": "Persons",
    "search by room name": "Search by room name",
    "join course": "Join course",
    "sorting": "Sorting",
    "participants": "Participants",
    "about course": "About Course",
    "course details": "Course details",
    "helpText": "<p><strong>Managing Courses:</strong> Create courses by selecting available instructors and rooms that fit your schedule. Set visibility to 'Club Level' for everyone or 'Private' for specific groups/individuals, and assign tasks to stay organized.</p><p><strong>Discovering & Joining:</strong> Browse available courses in Card or Calendar views for your preferred dates and join with a single click.</p>"
  },
  "appointmentAndClub": {
    "active": "Active",
    "start time": "Start Time",
    "end time": "End Time",
    "visibility": "Visibility",
    "event name": "Event Name",
    "event location": "Event Location",
    "room number (optional)": "Room Number (optional)",
    "event price": "Event Price",
    "additional features": "Additional Features",
    "show guests": "Show Guests",
    "chargeable": "Chargeable",
    "create event": "Create Event",
    "edit event": "Edit Event",
    "canceled": "Canceled",
    "pending": "Pending",
    "confirmed": "Confirmed",
    "location": "Location",
    "responsible": "Responsible",
    "join event": "Join Event",
    "current": "Current",
    "tile view": "Tile View",
    "list view": "List View",
    "board": "Board",
    "view": " View",
    "my contributions": "My Contributions",
    "Birthdays and anniversaries in the club": "Birthdays and anniversaries in the club",
    "Current events in the club": "Current events in the club",
    "Current events in the company": "Current events in the company"
  },
  "my content": {
    "title image": "Title image",
    "type": "Type",
    "actions": "Actions",
    "faqs": "FAQ's"
  },
  "userprofile": {
    "personal information": "Personal Information",
    "create profile": "Create Profile",
    "edit my profile": "Edit my profile",
    "digital membership card": "Digital membership card",
    "payment information": "Payment information",
    "digital card": "Digital Card",
    "card holder name": "Card Holder Name",
    "card number": "Card Number",
    "card type": "Card Type",
    "expiration date": "Expiration Date",
    "membership information": "Membership Information",
    "membership type": "Membership Type",
    "membership number": "Membership Number",
    "In the team since": "In the team since",
    "approval / activation": "Approval / Activation",
    "fair-share function": "Fair-Share Function"
  },
  "RRULE": {
    "approximate": "approximate",
    "and": "and",
    "at": "at",
    "day": "day",
    "days": "days",
    "every": "Every",
    "for": "for",
    "hour": "hour",
    "hours": "hours",
    "in": "in",
    "last": "last",
    "minutes": "minutes",
    "month": "month",
    "months": "months",
    "nd": "nd",
    "on the": "on the",
    "on": "on",
    "or": "or",
    "rd": "rd",
    "st": "st",
    "th": "th",
    "the": "the",
    "time": "time",
    "times": "times",
    "until": "until",
    "week": "week",
    "weekday": "weekday",
    "weekdays": "weekdays",
    "weeks": "weeks",
    "year": "year",
    "years": "years",
    "monthly": "month",
    "yearly": "year",
    "weekly": "week",
    "daily": "day",
    "hourly": "hour",
    "minutely": "minute",
    "secondly": "second",
    "starting from": "starting from",
    "MO": "Monday",
    "TU": "Tuesday",
    "WE": "Wednesday",
    "TH": "Thursday",
    "FR": "Friday",
    "SA": "Saturday",
    "SU": "Sunday",
    "RRule error: Unable to fully convert this rrule to text": "RRule error: Unable to fully convert this rrule to text"
  },
  "Add New": "Add New",
  "Create Group News": "Create Group News",
  "Create Group Task": "Create Group Task",
  "Create Group Event": "Create Group Event"
}
